import React from "react";

type Props = {
  rows?: number;
};

const Cell = ({ className }: { className: string }) => (
  <div className={`skeleton-shimmer h-3 rounded bg-slate-200 ${className}`} />
);

export const SubscriptionUsersTableSkeleton: React.FC<Props> = ({ rows = 10 }) => {
  return (
    <div className="overflow-x-auto mb-6 -mx-2 sm:mx-0">
      <style>
        {`
          @keyframes subscription-users-skeleton-shimmer {
            0% {
              background-position: 200% 0;
            }
            100% {
              background-position: -200% 0;
            }
          }

          @keyframes subscription-users-skeleton-fade {
            0%, 100% {
              opacity: 0.72;
              transform: translateY(0);
            }
            50% {
              opacity: 1;
              transform: translateY(-1px);
            }
          }

          .skeleton-shimmer {
            background-image: linear-gradient(
              90deg,
              #e2e8f0 0%,
              #f8fafc 18%,
              #cbd5e1 36%,
              #f8fafc 54%,
              #e2e8f0 72%
            );
            background-size: 220% 100%;
            animation: subscription-users-skeleton-shimmer 1.7s linear infinite,
              subscription-users-skeleton-fade 2.4s ease-in-out infinite;
            animation-delay: var(--skeleton-delay, 0ms);
            will-change: background-position, opacity, transform;
          }
        `}
      </style>
      <table className="min-w-[1200px] sm:min-w-full border border-gray-200 divide-y divide-gray-200 text-[11px] sm:text-xs">
        <thead className="bg-gray-900 text-white text-center text-[10px] sm:text-xs">
          <tr>
            <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">User</th>
            <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Status</th>
            <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Provider</th>
            <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Plan</th>
            <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Started</th>
            <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <tr
              key={i}
              className="text-center odd:bg-white even:bg-gray-50"
              style={{ "--skeleton-delay": `${i * 90}ms` } as React.CSSProperties}
            >
              <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
                <div className="flex items-center gap-2 p-2 rounded-lg border border-slate-200 bg-white shadow-sm">
                  <div className="skeleton-shimmer h-5 w-10 rounded" />
                  <div className="flex-1 min-w-0 space-y-2">
                    <Cell className="w-2/3 mx-auto" />
                    <Cell className="w-1/2 mx-auto" />
                  </div>
                </div>
              </td>
              <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
                <div className="flex justify-center">
                  <div className="skeleton-shimmer h-5 w-20 rounded-full" />
                </div>
              </td>
              <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
                <div className="flex justify-center">
                  <div className="skeleton-shimmer h-5 w-20 rounded-full" />
                </div>
              </td>
              <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
                <Cell className="w-16 mx-auto" />
              </td>
              <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
                <div className="space-y-2">
                  <Cell className="w-20 mx-auto" />
                  <Cell className="w-14 mx-auto" />
                </div>
              </td>
              <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
                <div className="flex justify-center">
                  <div className="skeleton-shimmer h-9 w-12 rounded-lg" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SubscriptionUsersTableSkeleton;

